import { ReactElement } from "react";

export enum MenuItemKey {
  edit = "edit",
  invite = "invite",
  resendInvitation = "resendInvitation",
  disable = "disable",
  enable = "enable",
  resetPassword = "resetPassword",
}

export interface MenuItem {
  key: MenuItemKey;
  icon: ReactElement;
  color?: string;
}

export interface MenuState {
  anchorEl: null | HTMLButtonElement;
  userId: string;
}
